import { useEffect, useMemo, useRef } from 'react';
import type { ReactNode } from 'react';
import { configure, useConfigStore, getConfig, type Config } from './_core/config.js';
import type { DeepPartial } from './_core/types.js';

export interface ConfigProviderProps {
  config?: DeepPartial<Config>;
  children: ReactNode;
}

export function ConfigProvider({ config, children }: ConfigProviderProps) {
  const initial = useRef(true);
  useMemo(() => {
    if (config) configure(config);
  }, [config]);

  useEffect(() => {
    if (initial.current) {
      initial.current = false;
      return;
    }
    if (config) configure(config);
  }, [config]);

  return <>{children}</>;
}

export function useConfig(): Config;
export function useConfig<T>(selector: (c: Config) => T): T;
export function useConfig<T>(selector?: (c: Config) => T): T | Config {
  return useConfigStore(selector ?? ((s: Config) => s as unknown as T));
}

export { configure, getConfig };
export type { Config };
